import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import ExternalIntegrationConfiguration from 'components/settings/externalIntegrationConfiguration/components/ExternalIntegrationConfiguration';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ExternalIntegrationConfiguration {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
